import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {Badge, Nav, NavItem, NavLink as RsNavLink} from 'reactstrap';
import classNames from 'classnames';
import SidebarMinimizer from './../SidebarMinimizer';


class Sidebar extends Component {
  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName, props) {
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
  }

  hideMenu() {
    document.body.classList.remove('sidebar-mobile-show')
  }

  render() {
    const props = this.props;
    const activeRoute = this.activeRoute;
    const handleClick = this.handleClick;

    let items = [
      {
        name: 'Startseite',
        url: '/home',
        icon: 'icon-home'
      },
      {
        name: 'Termine',
        url: '/termine',
        icon: 'icon-calendar'
      }
    ]

    if (props.userProfiles.length === 1) {
      items.splice(1, 0, {
        name: 'Profilseite',
        url: `/profiles/${props.userProfiles[0].id}`,
        icon: 'icon-badge'
      })
    } else {
      items.splice(1, 0, {
        name: 'Profilseiten',
        url: '/profiles',
        icon: 'icon-badge'
      })
    }

    items.push({
      name: 'Hilfe',
      url: 'http://partner-hilfe.fertighaus.de',
      icon: 'icon-info'
    })

    // badge addon to NavItem
    const badge = (badge) => {
      if (badge) {
        const classes = classNames( badge.class );
        return <Badge className={ classes } color={ badge.variant }>{badge.text}</Badge>
      }
    };

    // simple wrapper for nav-title item
    const wrapper = item => { return (item.wrapper && item.wrapper.element ? (React.createElement(item.wrapper.element, item.wrapper.attributes, item.name)): item.name ) };

    // nav list section title
    const title =  (title, key) => {
      const classes = classNames( "nav-title", title.class);
      return <li key={key} className={ classes }>{wrapper(title)}</li>
    };

    // nav list divider
    const divider = (divider, key) => <li key={key} className="divider"></li>

    // nav item with nav link
    const navItem = (item, key) => {
      const classes = classNames( item.class )
      const isExternal = (url) => (url.substring(0, 4) === 'http')

      const variant = classNames("nav-link", item.variant ? `nav-link-${item.variant}` : "")

      return (
        <NavItem key={key} className={classes}>
          { isExternal(item.url) ?
              <RsNavLink href={item.url} className={variant} target='_blank' active>
                <i className={item.icon}></i>{item.name}{badge(item.badge)}
              </RsNavLink>
            :
              <NavLink to={item.url} className={variant} activeClassName="active" onClick={this.hideMenu}>
                <i className={item.icon}></i>{item.name}{badge(item.badge)}
              </NavLink>
          }
        </NavItem>
      )
    };

    // nav dropdown
    const navDropdown = (item, key) => {
      return (
        <li key={key} className={activeRoute(item.url, props)}>
          <a className="nav-link nav-dropdown-toggle" href="#" onClick={handleClick.bind(this)}><i className={item.icon}></i>{item.name}</a>
          <ul className="nav-dropdown-items">
            {navList(item.children)}
          </ul>
        </li>)
    };

    // nav link
    const navLink = (item, idx) =>
      item.title ? title(item, idx) :
      item.divider ? divider(item, idx) :
      item.children ? navDropdown(item, idx)
                    : navItem(item, idx) ;

    // nav list
    const navList = (items) => {
      return items.map( (item, index) => navLink(item, index) );
    };

    // sidebar-nav root
    return (
      <div className="sidebar">
        <nav className="sidebar-nav">
          <Nav>
            {navList(items)}
          </Nav>
        </nav>
        <SidebarMinimizer/>
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js